/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssistantChatPostRequestMessageRole
 */
export interface AssistantChatPostRequestMessageRole {
}

/**
 * Check if a given object implements the AssistantChatPostRequestMessageRole interface.
 */
export function instanceOfAssistantChatPostRequestMessageRole(value: object): value is AssistantChatPostRequestMessageRole {
    return true;
}

export function AssistantChatPostRequestMessageRoleFromJSON(json: any): AssistantChatPostRequestMessageRole {
    return AssistantChatPostRequestMessageRoleFromJSONTyped(json, false);
}

export function AssistantChatPostRequestMessageRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssistantChatPostRequestMessageRole {
    return json;
}

export function AssistantChatPostRequestMessageRoleToJSON(json: any): AssistantChatPostRequestMessageRole {
    return AssistantChatPostRequestMessageRoleToJSONTyped(json, false);
}

export function AssistantChatPostRequestMessageRoleToJSONTyped(value?: AssistantChatPostRequestMessageRole | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

